export const LEGAL_PAGE_SLUGS = [
  'legal_notice',
  'terms_of_service',
  'terms_of_sale',
  'privacy',
  'cookies',
] as const

export type LegalPageSlug = (typeof LEGAL_PAGE_SLUGS)[number]

export function isLegalPageSlug(value: string): value is LegalPageSlug {
  return (LEGAL_PAGE_SLUGS as readonly string[]).includes(value)
}
